module.exports = __webpack_public_path__ + "static/use-case-2-content-4-41e3082b01868b94b6fca330193c57a3.png";